export const langCodes = {
  "af": true,
  "af-na": true,
  "af-za": true,
  "agq": true,
  "agq-cm": true,
  "ak": true,
  "ak-gh": true,
  "am": true,
  "am-et": true,
  "ar": true,
  "ar-001": true,
  "ar-ae": true,
  "ar-bh": true,
  "ar-dj": true,
  "ar-dz": true,
  "ar-eg": true,
  "ar-eh": true,
  "ar-er": true,
  "ar-il": true,
  "ar-iq": true,
  "ar-jo": true,
  "ar-km": true,
  "ar-kw": true,
  "ar-lb": true,
  "ar-ly": true,
  "ar-ma": true,
  "ar-mr": true,
  "ar-om": true,
  "ar-ps": true,
  "ar-qa": true,
  "ar-sa": true,
  "ar-sd": true,
  "ar-so": true,
  "ar-ss": true,
  "ar-sy": true,
  "ar-td": true,
  "ar-tn": true,
  "ar-ye": true,
  "as": true,
  "as-in": true,
  "asa": true,
  "asa-tz": true,
  "ast": true,
  "ast-es": true,
  "az": true,
  "az-cyrl": true,
  "az-cyrl-az": true,
  "az-latn": true,
  "az-latn-az": true,
  "bas": true,
  "bas-cm": true,
  "be": true,
  "be-by": true,
  "bem": true,
  "bem-zm": true,
  "bez": true,
  "bez-tz": true,
  "bg": true,
  "bg-bg": true,
  "bm": true,
  "bm-ml": true,
  "bn": true,
  "bn-bd": true,
  "bn-in": true,
  "bo": true,
  "bo-cn": true,
  "bo-in": true,
  "br": true,
  "br-fr": true,
  "brx": true,
  "brx-in": true,
  "bs": true,
  "bs-cyrl": true,
  "bs-cyrl-ba": true,
  "bs-latn": true,
  "bs-latn-ba": true,
  "ca": true,
  "ca-ad": true,
  "ca-es": true,
  "ca-es-valencia": true,
  "ca-fr": true,
  "ca-it": true,
  "ccp": true,
  "ccp-bd": true,
  "ccp-in": true,
  "ce": true,
  "ce-ru": true,
  "cgg": true,
  "cgg-ug": true,
  "chr": true,
  "chr-us": true,
  "ckb": true,
  "ckb-iq": true,
  "ckb-ir": true,
  "cs": true,
  "cs-cz": true,
  "cu": true,
  "cu-ru": true,
  "cy": true,
  "cy-gb": true,
  "da": true,
  "da-dk": true,
  "da-gl": true,
  "dav": true,
  "dav-ke": true,
  "de": true,
  "de-at": true,
  "de-be": true,
  "de-ch": true,
  "de-de": true,
  "de-it": true,
  "de-li": true,
  "de-lu": true,
  "dje": true,
  "dje-ne": true,
  "dsb": true,
  "dsb-de": true,
  "dua": true,
  "dua-cm": true,
  "dyo": true,
  "dyo-sn": true,
  "dz": true,
  "dz-bt": true,
  "ebu": true,
  "ebu-ke": true,
  "ee": true,
  "ee-gh": true,
  "ee-tg": true,
  "el": true,
  "el-cy": true,
  "el-gr": true,
  "en": true,
  "en-001": true,
  "en-150": true,
  "en-ag": true,
  "en-ai": true,
  "en-as": true,
  "en-at": true,
  "en-au": true,
  "en-bb": true,
  "en-be": true,
  "en-bi": true,
  "en-bm": true,
  "en-bs": true,
  "en-bw": true,
  "en-bz": true,
  "en-ca": true,
  "en-cc": true,
  "en-ch": true,
  "en-ck": true,
  "en-cm": true,
  "en-cx": true,
  "en-cy": true,
  "en-de": true,
  "en-dg": true,
  "en-dk": true,
  "en-dm": true,
  "en-er": true,
  "en-fi": true,
  "en-fj": true,
  "en-fk": true,
  "en-fm": true,
  "en-gb": true,
  "en-gd": true,
  "en-gg": true,
  "en-gh": true,
  "en-gi": true,
  "en-gm": true,
  "en-gu": true,
  "en-gy": true,
  "en-hk": true,
  "en-ie": true,
  "en-il": true,
  "en-im": true,
  "en-in": true,
  "en-io": true,
  "en-je": true,
  "en-jm": true,
  "en-ke": true,
  "en-ki": true,
  "en-kn": true,
  "en-ky": true,
  "en-lc": true,
  "en-lr": true,
  "en-ls": true,
  "en-mg": true,
  "en-mh": true,
  "en-mo": true,
  "en-mp": true,
  "en-ms": true,
  "en-mt": true,
  "en-mu": true,
  "en-mw": true,
  "en-my": true,
  "en-na": true,
  "en-nf": true,
  "en-ng": true,
  "en-nl": true,
  "en-nr": true,
  "en-nu": true,
  "en-nz": true,
  "en-pg": true,
  "en-ph": true,
  "en-pk": true,
  "en-pn": true,
  "en-pr": true,
  "en-pw": true,
  "en-rw": true,
  "en-sb": true,
  "en-sc": true,
  "en-sd": true,
  "en-se": true,
  "en-sg": true,
  "en-sh": true,
  "en-si": true,
  "en-sl": true,
  "en-ss": true,
  "en-sx": true,
  "en-sz": true,
  "en-tc": true,
  "en-tk": true,
  "en-to": true,
  "en-tt": true,
  "en-tv": true,
  "en-tz": true,
  "en-ug": true,
  "en-um": true,
  "en-us": true,
  "en-us-posix": true,
  "en-vc": true,
  "en-vg": true,
  "en-vi": true,
  "en-vu": true,
  "en-ws": true,
  "en-za": true,
  "en-zm": true,
  "en-zw": true,
  "eo": true,
  "eo-001": true,
  "es": true,
  "es-419": true,
  "es-ar": true,
  "es-bo": true,
  "es-br": true,
  "es-bz": true,
  "es-cl": true,
  "es-co": true,
  "es-cr": true,
  "es-cu": true,
  "es-do": true,
  "es-ea": true,
  "es-ec": true,
  "es-es": true,
  "es-gq": true,
  "es-gt": true,
  "es-hn": true,
  "es-ic": true,
  "es-mx": true,
  "es-ni": true,
  "es-pa": true,
  "es-pe": true,
  "es-ph": true,
  "es-pr": true,
  "es-py": true,
  "es-sv": true,
  "es-us": true,
  "es-uy": true,
  "es-ve": true,
  "et": true,
  "et-ee": true,
  "eu": true,
  "eu-es": true,
  "ewo": true,
  "ewo-cm": true,
  "fa": true,
  "fa-af": true,
  "fa-ir": true,
  "ff": true,
  "ff-cm": true,
  "ff-gn": true,
  "ff-mr": true,
  "ff-sn": true,
  "fi": true,
  "fi-fi": true,
  "fil": true,
  "fil-ph": true,
  "fo": true,
  "fo-dk": true,
  "fo-fo": true,
  "fr": true,
  "fr-be": true,
  "fr-bf": true,
  "fr-bi": true,
  "fr-bj": true,
  "fr-bl": true,
  "fr-ca": true,
  "fr-cd": true,
  "fr-cf": true,
  "fr-cg": true,
  "fr-ch": true,
  "fr-ci": true,
  "fr-cm": true,
  "fr-dj": true,
  "fr-dz": true,
  "fr-fr": true,
  "fr-ga": true,
  "fr-gf": true,
  "fr-gn": true,
  "fr-gp": true,
  "fr-gq": true,
  "fr-ht": true,
  "fr-km": true,
  "fr-lu": true,
  "fr-ma": true,
  "fr-mc": true,
  "fr-mf": true,
  "fr-mg": true,
  "fr-ml": true,
  "fr-mq": true,
  "fr-mr": true,
  "fr-mu": true,
  "fr-nc": true,
  "fr-ne": true,
  "fr-pf": true,
  "fr-pm": true,
  "fr-re": true,
  "fr-rw": true,
  "fr-sc": true,
  "fr-sn": true,
  "fr-sy": true,
  "fr-td": true,
  "fr-tg": true,
  "fr-tn": true,
  "fr-vu": true,
  "fr-wf": true,
  "fr-yt": true,
  "fur": true,
  "fur-it": true,
  "fy": true,
  "fy-nl": true,
  "ga": true,
  "ga-ie": true,
  "gd": true,
  "gd-gb": true,
  "gl": true,
  "gl-es": true,
  "gsw": true,
  "gsw-ch": true,
  "gsw-fr": true,
  "gsw-li": true,
  "gu": true,
  "gu-in": true,
  "guz": true,
  "guz-ke": true,
  "gv": true,
  "gv-im": true,
  "ha": true,
  "ha-gh": true,
  "ha-ne": true,
  "ha-ng": true,
  "haw": true,
  "haw-us": true,
  "he": true,
  "he-il": true,
  "hi": true,
  "hi-in": true,
  "hr": true,
  "hr-ba": true,
  "hr-hr": true,
  "hsb": true,
  "hsb-de": true,
  "hu": true,
  "hu-hu": true,
  "hy": true,
  "hy-am": true,
  "id": true,
  "id-id": true,
  "ig": true,
  "ig-ng": true,
  "ii": true,
  "ii-cn": true,
  "is": true,
  "is-is": true,
  "it": true,
  "it-ch": true,
  "it-it": true,
  "it-sm": true,
  "it-va": true,
  "ja": true,
  "ja-jp": true,
  "jgo": true,
  "jgo-cm": true,
  "jmc": true,
  "jmc-tz": true,
  "ka": true,
  "ka-ge": true,
  "kab": true,
  "kab-dz": true,
  "kam": true,
  "kam-ke": true,
  "kde": true,
  "kde-tz": true,
  "kea": true,
  "kea-cv": true,
  "khq": true,
  "khq-ml": true,
  "ki": true,
  "ki-ke": true,
  "kk": true,
  "kk-kz": true,
  "kkj": true,
  "kkj-cm": true,
  "kl": true,
  "kl-gl": true,
  "kln": true,
  "kln-ke": true,
  "km": true,
  "km-kh": true,
  "kn": true,
  "kn-in": true,
  "ko": true,
  "ko-kp": true,
  "ko-kr": true,
  "kok": true,
  "kok-in": true,
  "ks": true,
  "ks-in": true,
  "ksb": true,
  "ksb-tz": true,
  "ksf": true,
  "ksf-cm": true,
  "ksh": true,
  "ksh-de": true,
  "kw": true,
  "kw-gb": true,
  "ky": true,
  "ky-kg": true,
  "lag": true,
  "lag-tz": true,
  "lb": true,
  "lb-lu": true,
  "lg": true,
  "lg-ug": true,
  "lkt": true,
  "lkt-us": true,
  "ln": true,
  "ln-ao": true,
  "ln-cd": true,
  "ln-cf": true,
  "ln-cg": true,
  "lo": true,
  "lo-la": true,
  "lrc": true,
  "lrc-iq": true,
  "lrc-ir": true,
  "lt": true,
  "lt-lt": true,
  "lu": true,
  "lu-cd": true,
  "luo": true,
  "luo-ke": true,
  "luy": true,
  "luy-ke": true,
  "lv": true,
  "lv-lv": true,
  "mas": true,
  "mas-ke": true,
  "mas-tz": true,
  "mer": true,
  "mer-ke": true,
  "mfe": true,
  "mfe-mu": true,
  "mg": true,
  "mg-mg": true,
  "mgh": true,
  "mgh-mz": true,
  "mgo": true,
  "mgo-cm": true,
  "mk": true,
  "mk-mk": true,
  "ml": true,
  "ml-in": true,
  "mn": true,
  "mn-mn": true,
  "mr": true,
  "mr-in": true,
  "ms": true,
  "ms-bn": true,
  "ms-my": true,
  "ms-sg": true,
  "mt": true,
  "mt-mt": true,
  "mua": true,
  "mua-cm": true,
  "my": true,
  "my-mm": true,
  "mzn": true,
  "mzn-ir": true,
  "naq": true,
  "naq-na": true,
  "nb": true,
  "nb-no": true,
  "nb-sj": true,
  "nd": true,
  "nd-zw": true,
  "nds": true,
  "nds-de": true,
  "nds-nl": true,
  "ne": true,
  "ne-in": true,
  "ne-np": true,
  "nl": true,
  "nl-aw": true,
  "nl-be": true,
  "nl-bq": true,
  "nl-cw": true,
  "nl-nl": true,
  "nl-sr": true,
  "nl-sx": true,
  "nmg": true,
  "nmg-cm": true,
  "nn": true,
  "nn-no": true,
  "nnh": true,
  "nnh-cm": true,
  "nus": true,
  "nus-ss": true,
  "nyn": true,
  "nyn-ug": true,
  "om": true,
  "om-et": true,
  "om-ke": true,
  "or": true,
  "or-in": true,
  "os": true,
  "os-ge": true,
  "os-ru": true,
  "pa": true,
  "pa-arab": true,
  "pa-arab-pk": true,
  "pa-guru": true,
  "pa-guru-in": true,
  "pl": true,
  "pl-pl": true,
  "prg": true,
  "prg-001": true,
  "ps": true,
  "ps-af": true,
  "pt": true,
  "pt-ao": true,
  "pt-br": true,
  "pt-ch": true,
  "pt-cv": true,
  "pt-gq": true,
  "pt-gw": true,
  "pt-lu": true,
  "pt-mo": true,
  "pt-mz": true,
  "pt-pt": true,
  "pt-st": true,
  "pt-tl": true,
  "qu": true,
  "qu-bo": true,
  "qu-ec": true,
  "qu-pe": true,
  "rm": true,
  "rm-ch": true,
  "rn": true,
  "rn-bi": true,
  "ro": true,
  "ro-md": true,
  "ro-ro": true,
  "rof": true,
  "rof-tz": true,
  "root": true,
  "ru": true,
  "ru-by": true,
  "ru-kg": true,
  "ru-kz": true,
  "ru-md": true,
  "ru-ru": true,
  "ru-ua": true,
  "rw": true,
  "rw-rw": true,
  "rwk": true,
  "rwk-tz": true,
  "sah": true,
  "sah-ru": true,
  "saq": true,
  "saq-ke": true,
  "sbp": true,
  "sbp-tz": true,
  "sd": true,
  "sd-pk": true,
  "se": true,
  "se-fi": true,
  "se-no": true,
  "se-se": true,
  "seh": true,
  "seh-mz": true,
  "ses": true,
  "ses-ml": true,
  "sg": true,
  "sg-cf": true,
  "shi": true,
  "shi-latn": true,
  "shi-latn-ma": true,
  "shi-tfng": true,
  "shi-tfng-ma": true,
  "si": true,
  "si-lk": true,
  "sk": true,
  "sk-sk": true,
  "sl": true,
  "sl-si": true,
  "smn": true,
  "smn-fi": true,
  "sn": true,
  "sn-zw": true,
  "so": true,
  "so-dj": true,
  "so-et": true,
  "so-ke": true,
  "so-so": true,
  "sq": true,
  "sq-al": true,
  "sq-mk": true,
  "sq-xk": true,
  "sr": true,
  "sr-cyrl": true,
  "sr-cyrl-ba": true,
  "sr-cyrl-me": true,
  "sr-cyrl-rs": true,
  "sr-cyrl-xk": true,
  "sr-latn": true,
  "sr-latn-ba": true,
  "sr-latn-me": true,
  "sr-latn-rs": true,
  "sr-latn-xk": true,
  "sv": true,
  "sv-ax": true,
  "sv-fi": true,
  "sv-se": true,
  "sw": true,
  "sw-cd": true,
  "sw-ke": true,
  "sw-tz": true,
  "sw-ug": true,
  "ta": true,
  "ta-in": true,
  "ta-lk": true,
  "ta-my": true,
  "ta-sg": true,
  "te": true,
  "te-in": true,
  "teo": true,
  "teo-ke": true,
  "teo-ug": true,
  "tg": true,
  "tg-tj": true,
  "th": true,
  "th-th": true,
  "ti": true,
  "ti-er": true,
  "ti-et": true,
  "tk": true,
  "tk-tm": true,
  "to": true,
  "to-to": true,
  "tr": true,
  "tr-cy": true,
  "tr-tr": true,
  "tt": true,
  "tt-ru": true,
  "twq": true,
  "twq-ne": true,
  "tzm": true,
  "tzm-ma": true,
  "ug": true,
  "ug-cn": true,
  "uk": true,
  "uk-ua": true,
  "ur": true,
  "ur-in": true,
  "ur-pk": true,
  "uz": true,
  "uz-arab": true,
  "uz-arab-af": true,
  "uz-cyrl": true,
  "uz-cyrl-uz": true,
  "uz-latn": true,
  "uz-latn-uz": true,
  "vai": true,
  "vai-latn": true,
  "vai-latn-lr": true,
  "vai-vaii": true,
  "vai-vaii-lr": true,
  "vi": true,
  "vi-vn": true,
  "vo": true,
  "vo-001": true,
  "vun": true,
  "vun-tz": true,
  "wae": true,
  "wae-ch": true,
  "wo": true,
  "wo-sn": true,
  "xog": true,
  "xog-ug": true,
  "yav": true,
  "yav-cm": true,
  "yi": true,
  "yi-001": true,
  "yo": true,
  "yo-bj": true,
  "yo-ng": true,
  "yue": true,
  "yue-hans": true,
  "yue-hans-cn": true,
  "yue-hant": true,
  "yue-hant-hk": true,
  "zgh": true,
  "zgh-ma": true,
  "zh": true,
  "zh-hans": true,
  "zh-hans-cn": true,
  "zh-hans-hk": true,
  "zh-hans-mo": true,
  "zh-hans-sg": true,
  "zh-hant": true,
  "zh-hant-hk": true,
  "zh-hant-mo": true,
  "zh-hant-tw": true,
  "zu": true,
  "zu-za": true
}


// WEBPACK FOOTER //
// ./src/constants/consts-languages.js